/* eslint-disable no-return-await */
/* eslint-disable no-useless-constructor */
import axios from 'axios';
import config from 'config.json';
import { getApiUrlFromEnv, getOrchardUrlFromEnv, platforms } from 'utils/environment.util';
import { AuthentificationModel } from 'models/authentification.model';
import { useNavigate } from 'react-router-dom';

export class OAuth2Service {
 
  apiUrl = "";
  orchardUrl = "";
  env = process.env.REACT_APP_ENV_VAR ?? "";
  originUrl = process.env.REACT_APP_LEARNER_APP_URL ?? "";
  navigate = useNavigate();

  constructor() {
    this.apiUrl = getApiUrlFromEnv(this.env);
    this.orchardUrl = getOrchardUrlFromEnv(this.env);
  }

  authorize = (logout: boolean = false) => {
    const params = new URLSearchParams({
      response_type: "code",
      client_id: config.CLIENT_ID,
      redirect_uri: this.originUrl,
    });
  
    if (logout) {   
      sessionStorage.clear();
      params.append("max_age", "0");
    }
  
    const url = `${this.apiUrl}/api/oauth2/authorize?${params.toString()}`;
    window.location.href = url;
  };

  getAuth = async ({ code, refreshToken }: { code?: string; refreshToken?: string }) => {

    const params = new URLSearchParams();

    if (code) {
      params.append('grant_type', 'authorization_code');
      params.append('code', code);
    } else if (refreshToken) {
      params.append('grant_type', 'refresh_token');
      params.append('refresh_token', refreshToken);
    } else {
      throw new Error('Aucun code ni refresh_token fourni');
    }
  
    params.append('client_id', config.CLIENT_ID);

    return await axios
      .post(
        `${this.apiUrl}/api/oauth2/token`,
        params,
      )
      .then(async (res) => {
        const bo = await res?.data;
        if (res.status === 200) {
          return new AuthentificationModel(bo);
        }
        throw new Error(bo.error);
      })
      .catch((error) => {
        throw new Error(error);
      });
  };

  getCurrentUser = async () => {
    return await axios
      .get(`${this.apiUrl}/api/users/current`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
          'Content-Type': 'application/json',
        },
      })
      .then(async (res) => {
        const bo = await res?.data;
        if (res.status === 200) {
          return bo;
        }
        throw new Error(bo.error);
      });
  };

  checkUserSessionIsStillValid = async () => {
    const token = sessionStorage.getItem('accessToken');

    return await axios
    .post(`${this.orchardUrl}/oauth2/token_info`, {
        token: token
      }, {
        headers: {
          'content-type': 'application/x-www-form-urlencoded'
        }
      }
    )
    .then(async (res) => {
      const bo = await res?.data;
      if (res.status === 200) {
        return bo.active;
      }
      throw new Error(bo.error);
    })
    .catch((error) => {
      throw new Error(error);
    });
  };

  logout = () => {      
      sessionStorage.clear();

      process.env.REACT_APP_PLATFORM === platforms.WEB ? 
        window.location.href = `${this.orchardUrl}/logoff` : 
        this.navigate('disconnected');
  }

}
